import { render } from "./SliderBlock.vue?vue&type=template&id=a99371fc&ts=true"
import script from "./SliderBlock.vue?vue&type=script&lang=ts"
export * from "./SliderBlock.vue?vue&type=script&lang=ts"

import "./SliderBlock.vue?vue&type=style&index=0&id=a99371fc&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__